import Login from 'src/components/features/login/Login';

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
